import { Assets } from "pixi.js";

class SpriteSheetAssets {
    constructor() {
        this.explosion = null;
        this.scatter = null;
        this.icon1 = null;
        this.icon2 = null;
        this.icon3 = null;
        this.icon4 = null;
        this.icon5 = null;
        this.icon6 = null;
        this.icon7 = null;
        this.icon8 = null;
        this.icon9 = null;
        this.iconX = null;
        this.magicBall = null;
        this.book = null;
    }

    async loadSpriteSheets() {

        const assetPaths = [
            './assets/icons/explosion.json',
            './assets/icons/scatter.json',
            './assets/icons/icon1.json',
            './assets/icons/icon2.json',
            './assets/icons/icon3.json',
            './assets/icons/icon4.json',
            './assets/icons/icon5.json',
            './assets/icons/icon6.json',
            './assets/icons/icon7.json',
            './assets/icons/icon8.json',
            './assets/icons/icon9.json',
            './assets/icons/iconX.json',
            './assets/icons/magic-ball.json',
        ];

        const assets = await Promise.all(assetPaths.map(path=>Assets.load(path)));

        [
            this.explosion,
            this.scatter,
            this.icon1,
            this.icon2,
            this.icon3,
            this.icon4,
            this.icon5,
            this.icon6,
            this.icon7,
            this.icon8,
            this.icon9,
            this.iconX,
            this.magicBall,
            this.book,
        ] = assets;
    }

}
export const spriteSheetAssets = new SpriteSheetAssets();